/* eslint-disable */
import styled from "styled-components";
import React, { memo, useEffect, useState, useRef } from "react";
import EVC_GIF_ICON from "../../assets/images/EVC-fan-gif.gif";
import EVC_ICON from '../../assets/images/EVC-fan.png';
import { getFlexWidth } from "../../actions/passwordRegex";
import {
  getStringFromDecimalToBinary
} from "../../helpers";
import CommonDisplay from "./CommonDisplay";
import { EVC_LISTINGS_LIMIT, STAGE_ENABLED_REGISTERS } from "../../constants";
import { useParams } from "react-router-dom";

import {ReactComponent as SCROLL_ARROW} from "../../assets/images/scroll-arrow-icon.svg"

const GraphTypeWrapper = styled.div`
  // overflow: ${({ numDevices }) => (numDevices >= 7 ? "scroll" : "initial")};
  // white-space: ${({ numDevices }) => (numDevices >= 7 ? "nowrap" : "initial")};
  // flex: ${({ numDevices }) => `0 0 ${getFlexWidth(numDevices)}%`};
  // img {
  //   position: relative;
  //   width: 35px;
  //   cursor: pointer;
  // }
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const TankDevices = memo(
  ({
    currentTankData,
    tankType,
    setDeviceId,
    deviceType,
    deviceTypeGlobal,
    deviceId,
    setDeviceType,
    deviceIdObj,
    tankDeviceType,
    setCurrentActiveView,
    chillerAlertsList,
    turckTankName,
    turckControlSerialNumber,
    tanks = []
  }) => {
    const [currentEnableDeviceIDs, setCurrentEnableDeviceIDs] = useState(deviceIdObj);
    const [isFanRotating, setIsFanRotating] = useState(Array.from('0'.repeat(EVC_LISTINGS_LIMIT)));
    const [showAlertIcon, setShowAlertIcon] = useState({});
    const [evcAlertsByDeviceID, setEvcAlertsByDeviceID] = useState([])
    const { tankID } = useParams();
    const currentDevice = tanks.find(tank => tank.id === tankID);
    const scrollRef = useRef(null);
    const [scrollState, setScrollState] = useState({
      showScrollIcon: false, // Flag to check the content wider than the container
      scrollLeft: false,  // Is there hidden content on the left?
      scrollRight: false, // Is there hidden content on the right?
    });
    
    const updateScrollButtons = () => {
      if (scrollRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    
        setScrollState({
          showScrollIcon: scrollWidth > clientWidth,
          // Show left if we have scrolled more than 5px
          scrollLeft: scrollLeft > 5,
          // Show right if the (scrolled amount + visible width) is less than the total width
          scrollRight: scrollLeft + clientWidth < scrollWidth - 5,
        });
      }
    };
    
    useEffect(() => {
      updateScrollButtons();
      
      const el = scrollRef.current;
      if (el) {
        el.addEventListener('scroll', updateScrollButtons);
        window.addEventListener('resize', updateScrollButtons);
      }
    
      return () => {
        if (el) el.removeEventListener('scroll', updateScrollButtons);
        window.removeEventListener('resize', updateScrollButtons);
      };
    }, [currentEnableDeviceIDs]);

    useEffect(() => {
      // filtering only enable devices whenever live data emits
      if (currentTankData?.CHILLER && deviceIdObj?.CHILLER?.length && deviceIdObj?.EVC?.length && Object.keys(currentTankData.CHILLER).length) {
        const EVCDeviceIdsList = [];
        const compressorBits = [];
        const stageEnabledRegisters = STAGE_ENABLED_REGISTERS;
        for (let i = 0; i < EVC_LISTINGS_LIMIT; i++) {
          let isCompressorEnabled = currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_HOLD_REG_STAGE_${i + 1}_ENABLED_PARAM`]
          
          if(isCompressorEnabled === null || isCompressorEnabled === undefined) {
            const cloudSettingRegisters = currentDevice?.cloudSettingRegisters || {}
            isCompressorEnabled = cloudSettingRegisters[stageEnabledRegisters[i]]
          }
          isCompressorEnabled = Number(isCompressorEnabled)
          const EVCs = Object.keys(currentTankData?.["EVC"]);
          if (isCompressorEnabled) {
            const EVCDeviceData = {
                evcDeviceID: EVCs[i],
                compressorIndex: i,
                deviceNo: currentTankData?.EVC[EVCs[i]]?.device,
            };
            EVCDeviceIdsList.push(EVCDeviceData);
          }

          if(i + 1 > 6 && isCompressorEnabled) {
            compressorBits.push("1");
          }
                  }
        const relayStatusCompressorBits = getStringFromDecimalToBinary(currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_HOLD_REG_ONBOARD_RELAY_STATUS`]).slice(4, 10)
        setCurrentEnableDeviceIDs({ ...deviceIdObj, "EVC": EVCDeviceIdsList });
                setIsFanRotating([...relayStatusCompressorBits, ...compressorBits])
      }

      // when device is offline and on page load setting evc obj
      if(!Object.keys(currentTankData).length && Object.keys(deviceIdObj).length && deviceIdObj?.EVC?.length) {
        const EVCDeviceIdsList = [];
        for(let i = 0; i < deviceIdObj.EVC.length; i++) {
          EVCDeviceIdsList.push({ evcDeviceID: deviceIdObj.EVC[i], compressorIndex: i })
        }
        setCurrentEnableDeviceIDs({ ...deviceIdObj, "EVC": EVCDeviceIdsList });
      }
    }, [currentTankData, deviceIdObj]);

    function detectAlerts() {
      if (!chillerAlertsList.length) {
        // NO ALERTS FOUND;
        return;
      }
      const alertsByEvcDeviceID = []
      const updatedAlertIcons = {};

      for (let compressorIndex = 0; compressorIndex < EVC_LISTINGS_LIMIT; compressorIndex++) {
        updatedAlertIcons[compressorIndex] = { chillerDeviceSerialNumber: null, status: false };

        if (!chillerAlertsList.length) {
          break;
        }

        for (let chillerAlert of chillerAlertsList) {
          if (chillerAlert?.alertType?.includes('INDIVIDUAL') &&
            (
              chillerAlert?.configKey === `CHILLER_CONTROLLER_INPUT_REG_ALARMS_ACTIVE_1_BIT_${compressorIndex + 10}` ||
              chillerAlert?.configKey === `CHILLER_CONTROLLER_INPUT_REG_ALARMS_ACTIVE_2_BIT_${compressorIndex}`
            )
          ) {
            updatedAlertIcons[compressorIndex] = {
              chillerDeviceSerialNumber: chillerAlert.deviceSerialNumber,
              status: true,
            };
            break;
          }
        }
      }
      setShowAlertIcon(updatedAlertIcons);

      for (const chillerAlert of chillerAlertsList) {
        if(chillerAlert.deviceType === "EVC") {
          if(chillerAlert.alertType.includes("INDIVIDUAL") && chillerAlert.configKey.includes("EVC_INPUT_STATUS_REGISTER")) {
            alertsByEvcDeviceID.push(chillerAlert.deviceSerialNumber);
          }
        }
      }
      setEvcAlertsByDeviceID(alertsByEvcDeviceID);
    }

    const handleScroll = (direction) => {
      const distance = 200;
      if (scrollRef.current) {
        scrollRef.current.scrollBy({
          left: direction === 'left' ? -distance : distance,
          behavior: 'smooth'
        });
      }
    };

    useEffect(() => {
      detectAlerts();
    }, [chillerAlertsList]);

    return (
      <GraphTypeWrapper
        numDevices={
          deviceIdObj ? deviceIdObj.EVC.length + (deviceTypeGlobal === "HPF" ? deviceIdObj.HPF.length :  deviceTypeGlobal === 'CHILLER' ? deviceIdObj.CHILLER.length: deviceIdObj.TURCK_TANKS?.length) : 0
        }
      >
        {
          (deviceTypeGlobal === "HPF" || deviceTypeGlobal === "TURCK_TANKS")
            ?
            (deviceIdObj &&
              Object.keys(deviceIdObj).map((key) => {
                return deviceIdObj[key].map((id, index) => {
                  const evcIcon = Number.parseInt(currentTankData?.EVC?.[id]?.RUN_SIGNAL) === 1 ? EVC_GIF_ICON : EVC_ICON;

                  return (
                    <CommonDisplay
                      deviceId={deviceId}
                      id={id}
                      deviceKey={key}
                      deviceTypeGlobal={deviceTypeGlobal}
                      setDeviceId={setDeviceId}
                      setDeviceType={setDeviceType}
                      setCurrentActiveView={setCurrentActiveView}
                      deviceType={deviceType}
                      tankType={tankType}
                      evcIcon={evcIcon}
                      tankDeviceType={tankDeviceType}
                      currentTankData={currentTankData}
                      turckTankName={turckTankName}
                      turckControlSerialNumber={turckControlSerialNumber}
                    />
                  );
                });
              }))
            : deviceTypeGlobal === "CHILLER" ?
              (currentEnableDeviceIDs &&
                Object.keys(currentEnableDeviceIDs).map((key) => {
                  if (key === "CHILLER") {
                    return currentEnableDeviceIDs[key].map((id, index) => {
                      return (
                        <CommonDisplay
                          deviceId={deviceId}
                          id={id}
                          deviceKey={key}
                          deviceTypeGlobal={deviceTypeGlobal}
                          setDeviceId={setDeviceId}
                          setDeviceType={setDeviceType}
                          setCurrentActiveView={setCurrentActiveView}
                          deviceType={deviceType}
                          tankType={tankType}
                          tankDeviceType={tankDeviceType}
                          currentTankData={currentTankData}
                          showScrollIcon={scrollState.scrollLeft}
                        />
                      );
                    });
                  }

                  return (
                      <div className="evc-scrollbar-container d-flex">
                          {scrollState.showScrollIcon && scrollState.scrollLeft && (
                            <button
                              className="scroll-arrow left position-sticky btn btn-outline-light bg-transparent border-0"
                              style={{ left: 0 }}
                              onClick={() => handleScroll("left")}
                            >
                                <SCROLL_ARROW />
                            </button>
                          )}
                          <div
                              ref={scrollRef}
                              className="evc-scrollbar d-flex device-horizontal-scroll"
                          >
                              {currentEnableDeviceIDs[key].map(
                                  (
                                      {
                                          evcDeviceID,
                                          compressorIndex,
                                          deviceNo,
                                      },
                                      index
                                  ) => {
                                      const evcRotateSignal = Number(
                                          isFanRotating[index]
                                      );
                                      const evcDisabledSignal =
                                          Number.parseInt(
                                              currentTankData?.CHILLER?.[
                                                  deviceIdObj?.CHILLER?.[0]
                                              ]?.[
                                                  `CHILLER_CONTROLLER_HOLD_REG_COMPRESSOR_${deviceNo}_EVC_ENABLED_PARAM`
                                              ]
                                          ) === 0;
                                      const evcIcon = evcRotateSignal
                                          ? EVC_GIF_ICON
                                          : EVC_ICON;
                                      const isIndividualEvcAlertResolved = evcAlertsByDeviceID.includes(
                                          evcDeviceID
                                      );
                                      const alertIcon =
                                          (showAlertIcon[compressorIndex]
                                              ?.status &&
                                              currentEnableDeviceIDs
                                                  .CHILLER[0] ===
                                                  showAlertIcon[compressorIndex]
                                                      ?.chillerDeviceSerialNumber) ||
                                          isIndividualEvcAlertResolved ||
                                          false;
                                      let stageIndex =
                                          Number(
                                              currentTankData?.CHILLER?.[
                                                  deviceIdObj?.CHILLER?.[0]
                                              ]?.[
                                                  `CHILLER_CONTROLLER_INPUT_REG_STAGE_${deviceNo}_COMPRESSOR`
                                              ]
                                          ) + 1;

                                      return (
                                          <CommonDisplay
                                              deviceId={deviceId}
                                              id={evcDeviceID}
                                              deviceKey={key}
                                              deviceTypeGlobal={
                                                  deviceTypeGlobal
                                              }
                                              evcDisabledSignal={
                                                  evcDisabledSignal
                                              }
                                              index={compressorIndex}
                                              setDeviceId={setDeviceId}
                                              setDeviceType={setDeviceType}
                                              setCurrentActiveView={
                                                  setCurrentActiveView
                                              }
                                              deviceType={deviceType}
                                              tankType={tankType}
                                              evcIcon={evcIcon}
                                              stageIndex={stageIndex}
                                              tankDeviceType={tankDeviceType}
                                              currentTankData={currentTankData}
                                              alertIcon={alertIcon}
                                          />
                                      );
                                  }
                              )}
                          </div>
                          {scrollState.showScrollIcon && scrollState.scrollRight && (
                            <button
                              className="scroll-arrow right position-sticky btn btn-outline-light bg-transparent border-0"
                              style={{ right: 0 }}
                              onClick={() => handleScroll("right")}
                            >
                                <SCROLL_ARROW />
                            </button>
                          )}
                      </div>
                  );
                })) : null
        }

      </GraphTypeWrapper>
    );
  }
);

export default TankDevices;
